import React from "react";

function ProdottoSincronizzato({ articolo }) {
  let classeTemp = "bordinoColoreChiaro";

  if (articolo.errore) {
    classeTemp = "colAnnullato";
  }

  return (
    <div
      className={
        "ba pa3 pb3 br3 mr3 mb3 flex flex-column justify-between " + classeTemp
      }
    >
      <h2 className="tc">{articolo.codice}</h2>
      {articolo.errore && <h3>{articolo.errore}</h3>}
      {articolo.immagini.map((imm) => (
        <div className="bb pb2 mb2">
          <span className="b mr2">{imm.numero}</span>
          <span>id {imm.id}</span>
        </div>
      ))}
      <div className="mt3">ARCHIVIATO: {articolo.archiviato ? "Sì" : "No"}</div>
    </div>
  );
}

export default ProdottoSincronizzato;
